import React from "react";
import AppButton from "./AppButton.jsx";
import { cn } from "../../utils/themeClasses.js";

/**
 * Standard-Footer für Listen: fixe Seitengrösse, nur Zurück/Weiter.
 */
export default function ListPaginationFooter({
  visible = false,
  page = 1,
  pages = 1,
  onPrev,
  onNext,
  className,
}) {
  if (!visible) return null;

  const p = Math.max(1, Number(page) || 1);
  const pg = Math.max(1, Number(pages) || 1);

  return (
    <div
      className={cn(
        "rounded-xl px-3 py-2 border flex flex-wrap items-center justify-between gap-2 app-frame",
        className,
      )}
      role="navigation"
      aria-label="Seitennavigation"
    >
      <span className="text-xs text-blue-200/80" aria-live="polite">
        Seite {p} von {pg}
      </span>
      <div className="flex items-center gap-2">
        <AppButton
          type="button"
          variant="secondary"
          size="sm"
          disabled={p <= 1}
          onClick={onPrev}
          aria-label="Vorherige Seite"
        >
          Zurück
        </AppButton>
        <AppButton
          type="button"
          variant="secondary"
          size="sm"
          disabled={p >= pg}
          onClick={onNext}
          aria-label="Nächste Seite"
        >
          Weiter
        </AppButton>
      </div>
    </div>
  );
}
